import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myHrTempDataState = atom({
  key: "myHrTempDataState",
  default: undefined,
  effects_UNSTABLE: [ocPersistAtom],
});
